module.exports = __webpack_public_path__ + "media/images/pages/home/citizen-science-activities-1-aed53fac62bd21ca8cf0ea8d2d86ec5e.png";